import { AbstractPlayer } from "../types/abstract-player";
import { BallTypeEnum } from "../types/ball-type-enum";
export class Player {
  public playerId: string;
  public ballType: BallTypeEnum;
  public score: number = 0;
  public credits?: number | undefined;
  public enablePassback: boolean = false;
  public player: AbstractPlayer;
}
